import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";

import {
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  Tooltip,
  Legend
} from 'recharts';

const CourbeServiceHome = (props) => {

  const [t] = useTranslation('common');

  const CustomTooltip = ({ active, payload }) => {
    if (active) {
      return (
        <div className="custom-tooltip">
          <p className="label">
            {t("home.chart.time")} : {dayjs(payload[0].payload.time).format('HH:mm:ss')}<br />
            {t("home.chart.veh")} : {payload[0].payload.veh}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <React.Fragment>
      <ResponsiveContainer width="100%" height={400}>
        <ScatterChart width="100%" height="50%"
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <XAxis
            type="number"
            dataKey="time"
            name='time'
            domain={[1556438400000, 1556521200000]}
            tickFormatter={(unixTime) => dayjs(unixTime).format('HH:mm:ss')}
            ticks={[
              1556438400000,
              1556442000000, 1556445600000, 1556449200000, 1556452800000,
              1556456400000, 1556460000000, 1556463600000, 1556467200000,
              1556470800000, 1556474400000, 1556478000000, 1556481600000,
              1556485200000, 1556488800000, 1556492400000, 1556496000000,
              1556499600000, 1556503200000, 1556506800000, 1556510400000,
              1556514000000, 1556517600000, 1556521200000
            ]}
            angle={-90} dx={-4} textAnchor="end" height={100}
          />
          <YAxis yAxisId="left" dataKey="veh" name='véhicules'
            label={{ value: t("home.chart.veh"), angle: -90, position: 'insideLeft' }} />
          <ZAxis dataKey="z" range={[10]} />
          <Tooltip
            content={<CustomTooltip />}
          />
          <Legend formatter={(value, entry, index) =>
            <span style={{ color: "black" }} className="text-color-class">{value}</span>
          } />
          <Scatter
            yAxisId="left"
            name={t("home.chart.actual")}
            data={props.realtimeData}
            fill='#4d0077'
          />
          <Scatter
            yAxisId="left"
            name={t("home.chart.planned")}
            data={props.plannedData}
            fill='#c7c7c7'
          />
        </ScatterChart>
      </ResponsiveContainer>
    </React.Fragment >
  );
}

export default CourbeServiceHome;